<template>
  <b-modal
    ref="modal"
    :title="modalTitle"
    size="lg"
    hide-footer
    no-close-on-backdrop
    :no-close-on-esc="phase === 'running'"
    :hide-header-close="phase === 'running'"
    @hidden="onHidden"
  >
    <div v-if="phase === 'review'">
      <p class="text-dark mb-2">
        Sẽ phát hành <strong>{{ targets.length }}</strong> nháp điều chỉnh GTGT.
      </p>
      <p class="text-warning small mb-3">Lưu ý: thao tác không thể hoàn tác.</p>
      <ul class="small border rounded p-2 mb-0" style="max-height: 220px; overflow-y: auto">
        <li v-for="d in targets" :key="d.id" class="mb-1">
          <span class="font-weight-bold">{{ d.providerFlow }} — {{ d.returnBillNumber || d.returnBillId || '—' }}</span>
        </li>
      </ul>
      <div class="d-flex justify-content-end mt-3 pt-2 border-top">
        <b-button variant="light" class="mr-2" @click="hide">Hủy</b-button>
        <b-button variant="success" :disabled="issueSubmitting" @click="startIssue">
          <i class="fas fa-paper-plane mr-1"></i> Phát hành
        </b-button>
      </div>
    </div>

    <div v-else-if="phase === 'running'">
      <b-progress :max="targets.length" height="1.5rem" class="mb-2" striped animated>
        <b-progress-bar :value="processedCount" variant="success">
          {{ processedCount }} / {{ targets.length }}
        </b-progress-bar>
      </b-progress>
      <p class="small text-muted mb-0">{{ currentStepText }}</p>
    </div>

    <div v-else-if="phase === 'result'">
      <p class="mb-1">
        Thành công: <strong class="text-success">{{ successCount }}</strong>
      </p>
      <p v-if="failures.length" class="mb-2">
        Thất bại: <strong class="text-danger">{{ failures.length }}</strong>
      </p>
      <ul
        v-if="failures.length"
        class="small text-danger border rounded p-2 mb-0"
        style="max-height: 180px; overflow-y: auto"
      >
        <li v-for="(f, idx) in failures" :key="idx" class="mb-1">{{ f.label }}: {{ f.message }}</li>
      </ul>
      <div class="d-flex justify-content-end mt-3 pt-2 border-top">
        <b-button variant="primary" @click="hide">Đóng</b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ApiService from '@/core/services/api.service';

const PHASE = {
  IDLE: 'idle',
  REVIEW: 'review',
  RUNNING: 'running',
  RESULT: 'result',
};

export default {
  name: 'AdjustmentBulkIssueModal',
  data() {
    return {
      phase: PHASE.IDLE,
      targets: [],
      processedCount: 0,
      currentStepText: '',
      failures: [],
      successCount: 0,
      issueSubmitting: false,
    };
  },
  computed: {
    modalTitle() {
      if (this.phase === PHASE.RUNNING) return 'Đang phát hành…';
      if (this.phase === PHASE.RESULT) return 'Kết quả phát hành';
      return 'Phát hành hàng loạt nháp điều chỉnh';
    },
  },
  methods: {
    draftLabel(d) {
      const raw = d?.adjustmentInvoiceNo;
      if (raw != null && String(raw).trim() !== '') {
        return String(raw).trim();
      }
      return d?.draftCode || (d?.id != null ? `#${d.id}` : '—');
    },
    open(drafts) {
      this.targets = Array.isArray(drafts) ? drafts.filter((d) => d?.id && d?.actions?.canIssue) : [];
      this.failures = [];
      this.successCount = 0;
      this.processedCount = 0;
      this.currentStepText = '';
      this.issueSubmitting = false;
      if (!this.targets.length) {
        return;
      }
      this.phase = PHASE.REVIEW;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    onHidden() {
      const hadRun = this.phase === PHASE.RESULT || this.processedCount > 0;
      this.phase = PHASE.IDLE;
      this.targets = [];
      this.failures = [];
      this.successCount = 0;
      this.processedCount = 0;
      this.currentStepText = '';
      this.issueSubmitting = false;
      if (hadRun) {
        this.$emit('closed');
      }
    },
    async startIssue() {
      if (this.issueSubmitting || this.phase !== PHASE.REVIEW) return;
      this.issueSubmitting = true;
      try {
        this.phase = PHASE.RUNNING;
        this.failures = [];
        this.successCount = 0;
        this.processedCount = 0;

        for (let i = 0; i < this.targets.length; i += 1) {
          const d = this.targets[i];
          this.currentStepText = `Đang xử lý ${this.draftLabel(d)}…`;
          try {
            await ApiService.post(`v1/invoice-adjustment-drafts/${d.id}/issue`);
            this.successCount += 1;
          } catch (err) {
            const message = err?.response?.data?.message || err?.message || 'Lỗi không xác định';
            this.failures.push({ label: this.draftLabel(d), message });
          }
          this.processedCount = i + 1;
        }

        this.phase = PHASE.RESULT;
        this.currentStepText = '';
      } catch (e) {
        this.failures.push({
          label: 'Hệ thống',
          message: e?.message || 'Lỗi không xác định',
        });
        this.phase = PHASE.RESULT;
        this.currentStepText = '';
      } finally {
        this.issueSubmitting = false;
      }
    },
  },
};
</script>
